define('gigaset_contentbridge/components/customer-service',[
	"jquery",
	"cartware/components/_base",
	"gigaset_contentbridge/classes/utils"
], function(
	$,
	Component,
	$$
) {
	var utils = $$;

	return Component.create({
		$init: function() {
			this._initOnChange();
		},

		_initOnChange: function() {
			var selects = $('.b_contentbridge').find('[onchange]');

			selects.each(function() {
				var select = $(this),
					instruction = select.attr("onchange").replace(/^gigaset\./, "utils.");

				select.removeAttr("onchange");

				select.on("change", function(e) {
					e.preventDefault();
					e.stopPropagation();

					console.log(instruction);
					eval(instruction);
				});
			});
		}
	});
});
